/* global Q */

var _ = require('underscore');

var React = require("react");
var ReactDom = require("react-dom");
var moment = require('moment');
const createReactClass = require("create-react-class");
var form = require("../../deploynaut/js/Form.jsx");
const Modal = require('../../deploynaut/js/Modal.jsx');

const MFASettings = require('./mfa/MFASettings.jsx');

var external = {
	reloadSideMenu: function () {
		var navEl = $('.side-content .nav');
		$.get(navEl.data('nav'), function (data) {
			navEl.html(data);
		});
	},

	updateMenuUsername: function (val) {
		ReactDom.render(
			val,
			document.querySelector('.header-navbar .profile .title .username')
		);
	},

	updateMenuBadge: function (val) {
		ReactDom.render(
			val,
			document.querySelector('.header-navbar .profile .title .badge')
		);
	}
};

var Profile = createReactClass({

	getInitialState: function () {
		return {
			securityID: this.props.model.InitialSecurityID,
			roles: this.props.model.InitialRoles,
			organisations: this.props.model.InitialOrganisations,
			invites: this.props.model.InitialInvites,
			apiTokens: this.props.model.InitialAPITokens
		};
	},

	setSecurityID: function (id) {
		this.setState({ securityID: id });
	},

	updateState: function (data) {
		if (typeof data.NewSecurityID !== 'undefined') {
			this.setSecurityID(data.NewSecurityID);
		}
		var newState = {};
		if (typeof data.roles !== 'undefined') newState.roles = data.roles;
		if (typeof data.organisations !== 'undefined') newState.organisations = data.organisations;
		if (typeof data.invites !== 'undefined') newState.invites = data.invites;
		if (typeof data.apiTokens !== 'undefined') newState.apiTokens = data.apiTokens;
		this.setState(newState);
	},

	render: function () {
		let profileInvites = null;
		let orgMemberships = null;

		if (this.state.invites.length > 0) {
			profileInvites = (
				<ProfileInvites
					initialInvites={this.state.invites}
					securityID={this.state.securityID}
					handleUpdateState={this.updateState}
				/>
			);
		}

		let stackRoles = <p>No stacks are currently available to you.</p>;
		if (this.state.roles.length > 0) {
			stackRoles = (
				<div>
					<p>
                        Your current stack roles are listed below. Please contact
                        the relevant Stack Manager if you want to change these.
					</p>
					<ProfileRoles roles={this.state.roles} />
				</div>
			);
		}

		if (this.state.organisations.length > 0) {
			orgMemberships = (
				<div>
					<h3>Organisation roles</h3>
					<p>
						You are a member of the following organisations, which grants you access to all stacks managed by
						the organisation. Contact the Service Desk if you require changes made to your organisations.
					</p>
					<OrganisationRoles organisations={this.state.organisations} />
				</div>
			)

		}

		const apiTokens = (
			<div>
				<p>
                    Your API tokens allow programmatic access to manage your stacks
					{' '}
					<a href="/api">using the API</a>
.
                    These tokens should be treated like passwords and care should be taken to ensure that they are not made public.
				</p>
				<ProfileAPITokens
					apiTokens={this.state.apiTokens}
					model={this.props.model}
					securityID={this.state.securityID}
					handleUpdateState={this.updateState}
				/>
			</div>
		);

		return (
			<div className="row">
				<div className="col-md-4 col-sm-4 col-sm-push-8">
					<h3>Details</h3>
					<ProfilePane
						model={this.props.model}
						securityID={this.state.securityID}
						setSecurityID={this.setSecurityID}
					/>
				</div>
				<div className="col-md-8 col-sm-8 col-sm-pull-4">
					{profileInvites}
					<h3>Stack roles</h3>
					{stackRoles}

					{orgMemberships}

					<h3>API tokens</h3>
					{apiTokens}
				</div>
			</div>
		);
	}
});

var ProfilePane = createReactClass({

	getInitialState: function () {
		return {
			editVisible: false,
			passwordVisible: false,
			mfaVisible: false,
			noticeMessage: "",
			model: this.props.model
		};
	},

	componentDidUpdate: function () {
		if (this.state.editVisible) {
			document.getElementById('FirstName').focus();
		} else if (this.state.passwordVisible) {
			document.getElementById('Password').focus();
		}
	},

	getEditForm: function () {
		if (!this.state.editVisible) {
			return null;
		}
		return (
			<ProfileEditForm
				model={this.state.model}
				afterSuccess={this.editSuccess}
				securityID={this.props.securityID}
				cancelButton={<CancelButton callback={this.toggleEdit} />}
			/>
		);
	},

	getPasswordForm: function () {
		if (!this.state.passwordVisible) {
			return null;
		}
		return (
			<ProfilePasswordForm
				model={this.state.model}
				afterSuccess={this.passwordSuccess}
				securityID={this.props.securityID}
				cancelButton={<CancelButton callback={this.togglePassword} />}
			/>
		);
	},

	getMFAForm: function () {
		if (!this.state.mfaVisible) {
			return null;
		}
		return (
			<ProfileMFAForm
				model={this.state.model}
				cancelHandler={this.toggleMFA}
				securityID={this.props.securityID}
			/>
		);
	},

	getNotice: function () {
		if (!this.state.noticeMessage) {
			return null;
		}
		return (
			<div className="alert alert-success">
				{this.state.noticeMessage}
			</div>
		);
	},

	getProfileSummary: function () {
		if (this.state.passwordVisible || this.state.editVisible || this.state.mfaVisible) {
			return null;
		}

		return (
			<ProfileSummary
				model={this.state.model}
				toggleEdit={this.toggleEdit}
				togglePassword={this.togglePassword}
				toggleMFA={this.toggleMFA}
			/>
		);
	},

	passwordSuccess: function (data) {
		this.togglePassword();

		this.props.setSecurityID(data.NewSecurityID);
		this.setState({
			noticeMessage: "Your password has been updated"
		});
	},

	editSuccess: function (data) {
		this.toggleEdit();
		this.props.setSecurityID(data.NewSecurityID);

		// @todo(stig): need to reload the name and email after success
		var model = this.state.model;
		model.Details = data.Details;

		// update name in header nav
		external.updateMenuUsername(data.Details.Name);

		this.setState({
			noticeMessage: "Your profile has been updated",
			model: model
		});
	},

	togglePassword: function (event) {
		if (event) { event.preventDefault(); }

		this.setState({
			passwordVisible: !this.state.passwordVisible,
			noticeMessage: ""
		});
	},

	toggleMFA: function (event) {
		if (event) { event.preventDefault(); }

		this.setState({
			mfaVisible: !this.state.mfaVisible,
			noticeMessage: ""
		});
	},

	toggleEdit: function (event) {
		if (event) { event.preventDefault(); }
		this.setState({
			editVisible: !this.state.editVisible,
			noticeMessage: ""
		});

	},

	render: function () {
		return (
			<div className="profile-summary">
				{this.getNotice()}
				{this.getProfileSummary()}
				{this.getEditForm()}
				{this.getPasswordForm()}
				{this.getMFAForm()}
			</div>
		);
	}
});

var CancelButton = createReactClass({
	cancel: function (event) {
		event.preventDefault();
		this.props.callback();
	},
	render: function () {
		return (
			<button className="btn btn-link" onClick={this.cancel}>Cancel</button>
		);
	}
});

function ProfileSummary(props) {
	return (
		<div>
			<dl>
				<dt>Username</dt>
				<dd>{props.model.Details.Username}</dd>
				<dt>Name</dt>
				<dd>
					{props.model.Details.FirstName} {props.model.Details.Surname}
				</dd>
				<dt>Email</dt>
				<dd>{props.model.Details.Email}</dd>
				<dt>Dashboard Timezone</dt>
				<dd>
					{props.model.Details.Timezone ? props.model.Details.Timezone : props.model.DefaultTimezone}
				</dd>
				<dt>Mobile phone</dt>
				<dd>{props.model.Details.MobileNumber}</dd>
			</dl>
			<div className="actions">
				<button className="btn btn-primary" onClick={props.toggleEdit}>Edit profile</button>
				<br />
				<button className="btn btn-primary" onClick={props.togglePassword}>Change password</button>
				<br />
				<button className="btn btn-primary" onClick={props.toggleMFA}>MFA settings</button>
			</div>
		</div>
	);
}

function ProfileEditForm(props) {
	var details = props.model.Details;
	const mobilePhoneProps = {};
	if (props.model.MobilePhoneRequired) {
		mobilePhoneProps.required = 'required';
		mobilePhoneProps.validationError = 'You must supply a phone number to authorise stack changes';
	}
	const mobilePhone = (
		<div className="form-group">
			<label htmlFor="MobileNumber">Mobile phone</label>
			<form.Input
				name="MobileNumber"
				value={details.MobileNumber}
				{...mobilePhoneProps}
			/>
		</div>
	);
	return (
		<form.Form
			url={props.model.DetailsUpdateUrl}
			securityID={props.securityID}
			buttonTitle="Update"
			buttonSubmittingTitle="Saving"
			afterSuccess={props.afterSuccess}
			cancelButton={props.cancelButton}
		>
			<div className="form-group">
				<label htmlFor="FirstName">First name</label>
				<form.Input
					name="FirstName"
					value={details.FirstName}
					required
					validationError="Please enter your first name"
				/>
			</div>
			<div className="form-group">
				<label htmlFor="Surname">Surname</label>
				<form.Input
					name="Surname"
					value={details.Surname}
					required
					validationError="Please enter your surname"
				/>
			</div>
			<div className="form-group">
				<label htmlFor="Timezone">Dashboard Timezone</label>
				<form.Select
					name="Timezone"
					required
					validationError="Please choose a timezone"
					options={props.model.Timezones}
					value={props.model.Details.Timezone ? props.model.Details.Timezone : props.model.DefaultTimezone}
				/>
			</div>
			{mobilePhone}
		</form.Form>
	);
}

function ProfileMFAForm(props) {
	return (
		<div>
			<MFASettings
				model={props.model}
				cancelHandler={props.cancelHandler}
			/>
		</div>
	);
}

var ProfilePasswordForm = createReactClass({

	render: function () {
		return (
			<form.Form
				url={this.props.model.ChangePasswordUrl}
				securityID={this.props.securityID}
				buttonTitle="Change password"
				buttonSubmittingTitle="Updating"
				afterSuccess={this.props.afterSuccess}
				cancelButton={this.props.cancelButton}
			>
				<div>
					<div className="form-group">
						<label htmlFor="CurrentPassword">Current password</label>
						<form.Password name="CurrentPassword" required validationError="Please enter your current password" />
					</div>
					<div className="form-group">
						<label htmlFor="Password">New password</label>
						<form.Password name="Password" required validationError="Please enter a valid password" />
						<div className="help-text">
                            Please ensure your password contains a mix of
                            lowercase letters, uppercase letters, numbers, and symbols.
						</div>
					</div>
					<div className="form-group">
						<label htmlFor="Password_confirm">Confirm password</label>
						<form.Password
							name="Password_confirm"
							validations='equalsField|"Password"|"Password_confirm"'
							required
							validationError="Passwords must match"
						/>
					</div>
				</div>
			</form.Form>
		);
	}
});

function ProfileRoles(props) {
	var rows = _.map(props.roles, function (item) {
		return (
			<tr key={item.GroupID + '-' + item.ProjectID}>
				<td><a href={item.ProjectLink}>{item.Project}</a></td>
				<td>{item.RoleTitle}</td>
				<td><i>Active</i></td>
			</tr>
		);
	});

	return (
		<div>
			<table className="profile-role-table table">
				<thead>
				<tr>
					<th>Stack</th>
					<th>Role</th>
					<th>State</th>
				</tr>
				</thead>
				<tbody>
				{rows}
				</tbody>
			</table>
		</div>
	);
}

function OrganisationRoles(props) {
	var rows = _.map(props.organisations, function (item) {
		return (
			<tr key={item.ID + '-' + item.RoleTitle}>
				<td>{item.Organisation}</td>
				<td>{item.RoleTitle}</td>
			</tr>
		);
	});

	return (
		<div>
			<table className="profile-role-table table">
				<thead>
				<tr>
					<th>Organisation</th>
					<th>Role</th>
				</tr>
				</thead>
				<tbody>
				{rows}
				</tbody>
			</table>
		</div>
	);
}

var ProfileAPITokens = createReactClass({
	getInitialState: function () {
		return {
			modal: null,
			saving: false,
			message: null,
			messageType: null
		};
	},

	cancelModalHandler: function (event) {
		if (event) {
			event.preventDefault();
		}
		this.setState({
			modal: null,
			saving: false
		});
	},

	getModal: function (form, title, large) {
		if (!form) {
			return null;
		}

		return (
			<Modal
				closeHandler={this.cancelModalHandler}
				title={title}
				large={large}
			>
				{form}
			</Modal>
		);
	},

	afterSuccess(data) {
		this.props.handleUpdateState(data.data);

		this.setState({
			modal: null,
			saving: false,
			message: data.message,
			messageType: "success",
		});
	},

	addToken() {
		this.setState({
			modal: this.getModal(
				<APITokenForm
					model={this.props.model}
					securityID={this.props.securityID}
					afterSuccess={this.afterSuccess}
				/>,
				'Generate an API Token', true
			)
		});
	},

	removeToken(data) {
		this.setState({
			saving: true,
			message: ""
		});

		var postData = {
			DispatcherSecurityID: this.props.securityID,
			ID: data.id
		};

		var self = this;
		Q($.ajax({
			type: "POST",
			url: self.props.model.RevokeTokenURL,
			data: postData
		}))
			.then(function (data) {
				self.props.handleUpdateState(data.data);
				self.setState({
					saving: false,
					message: "API token revoked",
					messageType: "success"
				});
			}, function (data) {
				var text = data.responseText.charAt(0).toLowerCase() + data.responseText.slice(1);
				self.setState({
					saving: false,
					message: "Failed to revoke token: " + text,
					messageType: "danger"
				});
			});
	},

    render: function() {
        var self = this;
        var rows = _.map(this.props.apiTokens, function(item) {
            return (
                <tr key={item.id}>
                    <td>{item.name}</td>
                    <td className='pre-line'>{item.ip_whitelist}</td>
                    <td title={item.last_accessed}>{item.last_accessed ? moment(item.last_accessed).fromNow() : 'never'}</td>
                    <td title={item.created}>{moment(item.created).fromNow()}</td>
                    <td>
                        <button
                            type="button"
							className="btn btn-danger btn-sm btn-icon-only"
                            disabled={self.state.saving}
                            onClick={() => self.removeToken(item)}
                        >
                            <i className="fa fa-times no-text"></i>
                        </button>
                    </td>
                </tr>
            );
        });

		var message = "";
		if (this.state.message) {
			message = (
				<div
					className={'alert alert-' + this.state.messageType}
					dangerouslySetInnerHTML={{ __html: this.state.message }}
				/>
			);
		}

		let table;
		if (rows.length > 0) {
			table = (
				<table className="profile-role-table table">
					<thead>
						<tr>
							<th>Token Name</th>
							<th>Whitelisted IP Addresses</th>
							<th>Last Used</th>
							<th>Created</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{rows}
					</tbody>
				</table>
			);
		}

		return (
			<div>
				{message}
				{table}

				<div className='actions'>
					<button
						type="button"
						className="btn btn-primary"
						onClick={this.addToken}
					>
                        Generate API token
					</button>
				</div>
				{this.state.modal}
			</div>
		);
	}
});

var APITokenForm = createReactClass({
	render: function () {
		return (
			<form.Form
				url={this.props.model.GenerateTokenURL}
				securityID={this.props.securityID}
				buttonTitle="Generate token"
				buttonSubmittingTitle="Generating"
				afterSuccess={this.props.afterSuccess}
			>

				<div className="form-group">
					<label htmlFor="Name">Name</label>
					<form.Input
						name="Name"
						required
						validationError="Please enter a name for your API token"
						placeholder="e.g CI Build Process"
					/>
				</div>
				<div className="form-group">
					<label htmlFor="IPWhitelist">Whitelisted IP Addresses (one per line)</label>
					<form.Textarea
						name="IPWhitelist"
						placeholder="Enter each IP address or CIDR range on its own line"
						rows='4'
					/>
					<span className='help-text'>
                        Leave blank to allow any IP address to use this API token (not recommended)
					</span>
				</div>
			</form.Form>
		);
	}
});

var ProfileInvites = createReactClass({

	getInitialState: function () {
		return {
			saving: false,
			message: "",
			messageType: "success"
		};
	},

	acceptInvite: function (item) {

		this.setState({
			saving: true,
			message: ""
		});

		var postData = {
			DispatcherSecurityID: this.props.securityID
		};

		var self = this;
		Q($.ajax({
			type: "POST",
			url: item.AcceptInviteUrl,
			data: postData
		}))
			.then(function (data) {
				self.props.handleUpdateState(data);
				self.setState({
					saving: false,
					message: "Invite accepted.",
					messageType: "success",
				});
				external.reloadSideMenu();
				if (typeof data.invites !== 'undefined' || !data.invites.length) {
					external.updateMenuBadge('');
				} else {
					external.updateMenuBadge(data.invites.length);
				}
			}, function (data) {
				self.props.handleUpdateState(data);
				var text = data.responseText.charAt(0).toLowerCase() + data.responseText.slice(1);
				self.setState({
					saving: false,
					message: "Failed to accept invite: " + text,
					messageType: "danger"
				});
			});
	},

	rejectInvite: function (item) {

		this.setState({
			saving: true,
			message: ""
		});

		var postData = {
			DispatcherSecurityID: this.props.securityID
		};

		var self = this;
		Q($.ajax({
			type: "POST",
			url: item.RejectInviteUrl,
			data: postData
		}))
			.then(function (data) {
				self.props.handleUpdateState(data);
				self.setState({
					saving: false,
					message: "Invite rejected.",
					messageType: "success"
				});
				if (typeof data.invites !== 'undefined' || !data.invites.length) {
					external.updateMenuBadge('');
				} else {
					external.updateMenuBadge(data.invites.length);
				}
			}, function (data) {
				self.props.handleUpdateState(data);
				var text = data.responseText.charAt(0).toLowerCase() + data.responseText.slice(1);
				self.setState({
					saving: false,
					message: "Failed to reject invite: " + text,
					messageType: "danger"
				});
			});
	},

	handlerForItem: function (handler, item) {
		return function () {
			handler(item);
		};
	},

	render: function () {

		var message = "";
		if (this.state.message) {
			message = (
				<div
					className={'alert alert-' + this.state.messageType}
					dangerouslySetInnerHTML={{ __html: this.state.message }}
				/>
			);
		}

		var self = this;
		var rows = _.map(this.props.initialInvites, function (item) {
			return (
				<tr key={item.ID}>
					<td>{item.Project}</td>
					<td>{item.RoleTitle}</td>
					<td>
						<button
							type="button"
							className="btn btn-success btn-sm btn-icon-only"
							disabled={self.state.saving}
							onClick={self.handlerForItem(self.acceptInvite, item)}
						>
							<i className="fa fa-check no-text"></i>
						</button>

                        <button
                            type="button"
                            className="btn btn-danger btn-sm btn-icon-only"
                            disabled={self.state.saving}
                            onClick={self.handlerForItem(self.rejectInvite, item)}
                        >
                            <i className="fa fa-times no-text"></i>
                        </button>
                    </td>
                </tr>
            );
        });

		return (

			<div>
				<h3>Stack invites</h3>
				<p>Your current stack invites are listed below. You can accept or decline them.</p>
				{message}
				<table className="profile-invite-table table table-striped">
					<thead>
						<tr>
							<th>Stack</th>
							<th>Role</th>
							<th>Respond</th>
						</tr>
					</thead>
					<tbody>
						{rows}
					</tbody>
				</table>
			</div>
		);
	}
});

module.exports = Profile;

